// Shared registries. Each section (module) adds its own handlers here at start up.
// A: click actions (data-act="name")      C: change handlers (data-chg="name")
// INPUTS: typing handlers (data-inp)      ENTERS: Enter-key handlers (data-enter)
// KEYS / CLICKS: global hooks, return true when they handled the event
// UPLOADS: file chooser handlers keyed by UI.upMode
export const A = {};
export const C = {};
export const INPUTS = {};
export const ENTERS = {};
export const KEYS = [];
export const CLICKS = [];
export const UPLOADS = {};
